import { EvaAddress } from "src/app/domains/address";

export class EvaCompanyBillingConfig {
  public qr_invoice_enabled: boolean = false;
  public never_show_empty_iban_alert_again: boolean = false;
  public never_show_invalid_iban_alert_again: boolean = false;
  public payable_to_account: string = "";
  public payable_to_name: string = "";
  public payable_to_address: string = "";
  public payable_to_address_details: EvaAddress = new EvaAddress();

  constructor() {
    this.payable_to_address_details = new EvaAddress();
  }

  public static createInstance(jsonData: any): EvaCompanyBillingConfig {
    const e = Object.assign(new EvaCompanyBillingConfig(), jsonData);

    if (jsonData.payable_to_address_details) {
      e.payable_to_address_details = EvaAddress.createInstance(jsonData.payable_to_address_details);
    }

    return e;
  }
}
